export const TITLE = 'Phone Verification Terms';
export const VERIFICATION_HEADER = 'Phone Verification Terms';
export const VERIFICATION_BODY =
  'You authorize your wireless carrier to use or disclose information about your account and your wireless device, if available, to CVS or its service provider for the duration of your business relationship, solely to help them identify you or your wireless device and to prevent fraud. See our <a href="javascript:;" id="privacyPolicyLink">Privacy Policy</a> for how we treat your data.';
export const TERMS = 'Terms of Use';
export const AND = 'and';
export const PRIVACY_LINK = 'Privacy Policy';

export const CONS = {
  TITLE,
  VERIFICATION_HEADER,
  VERIFICATION_BODY,
  TERMS,
  AND,
  PRIVACY_LINK
};

// i18n Translation Configuration
export const PHONE_VERIFICATION_TRANSLATION_CONFIG = [
  { key: 'TITLE', value: TITLE, message: TITLE },
  { key: 'VERIFICATION_HEADER', value: VERIFICATION_HEADER, message: VERIFICATION_HEADER },
  { key: 'VERIFICATION_BODY', value: VERIFICATION_BODY, message: VERIFICATION_BODY },
  { key: 'TERMS', value: TERMS, message: TERMS },
  { key: 'AND', value: AND, message: AND },
  { key: 'PRIVACY_LINK', value: PRIVACY_LINK, message: PRIVACY_LINK }
];

// Process translated items for phone-verification page
export const processPhoneVerificationTranslations = (translatedItems: Record<string, string>) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }

  // Destructure simple string values with fallbacks
  const {
    [TITLE]: TITLE_TRANSLATED = TITLE,
    [VERIFICATION_HEADER]: VERIFICATION_HEADER_TRANSLATED = VERIFICATION_HEADER,
    [VERIFICATION_BODY]: VERIFICATION_BODY_TRANSLATED = VERIFICATION_BODY,
    [TERMS]: TERMS_TRANSLATED = TERMS,
    [AND]: AND_TRANSLATED = AND,
    [PRIVACY_LINK]: PRIVACY_LINK_TRANSLATED = PRIVACY_LINK
  } = translatedItems;

  return {
    TITLE: TITLE_TRANSLATED,
    VERIFICATION_HEADER: VERIFICATION_HEADER_TRANSLATED,
    VERIFICATION_BODY: VERIFICATION_BODY_TRANSLATED,
    TERMS: TERMS_TRANSLATED,
    AND: AND_TRANSLATED,
    PRIVACY_LINK: PRIVACY_LINK_TRANSLATED
  };
};
